module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"539\" height=\"528.103\" viewBox=\"0 0 539 528.103\"><defs><style>.a{fill:#f7f7f7;}</style></defs><path class=\"a\" d=\"M269.5,0C419.369-55.634,539,122,539,272.5S424.26,472.482,269.5,510.737,0,423,0,272.5,119.631,55.634,269.5,0Z\" transform=\"translate(0 10.444)\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/circle-background1.svg
// module id = 397
// module chunks = 0